<template>
  <div class="alert" v-if="alertshow">
    <div class="con">
      <div class="tit">用户服务协议</div>
      <div class="btm">
        <div class="fal" @click="unagree">拒绝</div>
        <div class="tru" @click="agree">同意</div>
      </div>
      <div class="content-wrap">
        <div class="content">
          <p class="p1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;图灵科技依据本协议提供语义解析服务，本协议在使用者和图灵科技间具有合同上的法律效力。
            使用者一经注册或使用本协议下任何服务即视为对本协议条款的理解和接受， 使用者违反本协议时图灵科技有权按其违反情况限制或停止向使用者提供语义解析服务，并有权追究使用者的相关责任。
            本协议可由图灵科技随时更新，使用者可在图灵机器人查阅最新版协议内容。
            如在图灵科技修改协议后，使用者不接受修改后的协议，请立即停止使用语义解析服务，如使用者继续使用语义解析服务，将视为已接受修改后的协议。</p>
          <p class="p2">授权内容</p>
          <p class="p1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本协议的授权产品是图灵科技NGLP，是指采用了图灵科技拥有自主知识产权的语义解析技术的解析平台。其主要功能包括句子分词、单词解析和NER。</p>
          <p class="p2">双方的权利义务</p>
          <p class="p1">1、使用者承诺确保图灵科技NGLP在其产品中正常使用，即保证图灵科技NGLP的句子分词、单词解析和NER等功能能够正常使用，否则视为违约行为。</p>
          <p class="p1">
            2、为保证图灵科技NGLP的合法使用，使用者集成图灵科技NGLP的产品上市前，须把该产品在图灵机器人网站激活，未经图灵科技审核的帐号将无法使用解析服务，经图灵科技审核通过的产品才能正式上线。 </p>
          <p class="p1">
            3、使用者申请图灵科技NGLP时，在图灵机器人所填写的联系方式等信息和提交应用审核的信息等都是准确有效的，并且使用者所申请的图灵科技NGLP只能使用在申请信息所对应的产品中。若有多个产品，使用者应分多次申请图灵科技NGLP，否则视为违约行为。</p>
          <p class="p1">
            4、使用者在所有涉及图灵科技NGLP的介绍中（应包括但不限于软件帮助文档、产品使用说明书、产品包装、宣传彩页、网站、广告），需指明图灵科技NGLP由“图灵科技”提供，在涉及语义解析技术介绍界面中，需注明“语义解析技术由图灵科技提供”。</p>
          <p class="p1">
            5、使用者在未经图灵科技书面同意前，不得对图灵科技NGLP中技术软件或文件或其任何部分进行单独销售、转让、出租、转授权；并不得从事反汇编、反编辑以及分解、分析、修改以上软件的行为。 </p>
          <p class="p2">知识产权</p>
          <p class="p1">1、图灵科技保证，本协议中图灵科技NGLP所涉及的知识产权全部归图灵科技所有，为图灵科技开发、设计，并无抄袭、仿冒、节录或改编他人相同或相似功能软件或其它侵害他人著作权。</p>
          <p class="p1">2、图灵科技保证任何第三方都不能因使用者按本协议约定方式生产、销售、使用了图灵科技NGLP而向使用者索取任何权利或要求。</p>
          <p class="p1">3、所有一方专有的和非公开的知识，方法以及其它信息，在开发过程中为另一方获知或者得到，知识产权仍归原有一方所有。</p>
          <p class="p1">4、图灵科技保证，本协议中所涉及的合作标的的知识产权不存在任何瑕疵，不会侵犯任何第三方的合法权益。</p>
          <p class="p2">保密条款</p>
          <p class="p1">
            1、图灵科技采取一切措施严格保护使用者提交的资料，在事先没有得到使用者书面同意时不得向任何第三方以任何形式泄漏任何资料。资料应包括但不限于双方提供的一切设计开发有关的信息、结果，以及协议联系期间双方或双方代表与对方交流的对方以前未知的信息。</p>
          <p class="p1">
            2、图灵科技不允许任何人在未经使用者同意的情况利用图灵科技提供的服务以任何手段编辑、出售、传播使用者的资料。一经发现使用者实施上述行为，图灵科技有权立即终止与该使用者的服务协议，终止为其提供任何语义解析服务，并有权追究其法律责任。</p>
          <p class="p2">协议终止</p>
          <p class="p1">1、如遇下列情况之一，经一方发出书面通知后即可提前终止协议：</p>
          <p class="p1"> • 任何一方严重违反本协议的实质性义务，经守约方书面通知（书面形式包括通知函、传真、以及邮件等方式）后，在规定期限内未能采取有效的补救措施以纠正违约行为的；</p>
          <p class="p1">• 除适用破产法所禁止的情形外，如果任何一方出于债权人的利益，已被指定接收人或资产受让人、或破产或无力偿付到期债务或因其他事由丧失履约能力； </p>
          <p class="p1">本协议无论因何种原因终止后，本协议保密、知识产权、抗辩、违约责任及其他依其性质应继续有效的条款应继续有效，并不损害受损方寻求其它救济的权利。 </p>
          <p class="p1">2、使用者应按照图灵科技的标准规定使用NGLP，如使用者出现违反授权协议条约的行为，则图灵科技有权停止向使用者提供语义解析服务。</p>
          <p class="p2">免责条款</p>
          <p class="p1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;鉴于语义解析服务需要网络支撑，图灵科技有权对提供网路服务的平台或相关设备进行部分或全部的维护、切换，如因此类情况造成的网络服务在一定时间内出现中断，图灵科技无需通知使用者，也无需承担任何责任。</p>
          <p class="p2">其它条款</p>
          <p class="p1">1、图灵科技对本协议条款拥有解释权。</p>
          <p class="p1" style="margin-bottom: 20px;">2、执行本协议所发生的以及与本协议有关的一切争议，双方友好协商解决，若协商不成，双方同意提交图灵科技所在地人民法院诉讼解决</p>
        </div>
      </div>

      <span @click="close">×</span>
    </div>
  </div>
</template>

<script>
    export default{
      props: {
        alertshow: {
          type: Boolean
        }
      },
      methods: {
        close () {
          this.$emit('close');
        },
        agree () {
          this.$emit('agree');
        },
        unagree () {
          this.$emit('unagree');
        }
      }
    };
</script>

<style lang="scss" scoped="" type="text/css">
  .alert{position: fixed;left: 0;right: 0;top: 0;bottom: 0;background: rgba(0,0,0,.5);z-index: 1000;
    .con{width: 544px;height: 80%; background: #fff;margin: 5% auto;-webkit-box-shadow:0 0 5px 0 rgba(0,0,0,.3);-moz-box-shadow:0 0 5px 0 rgba(0,0,0,.3);box-shadow:0 0 5px 0 rgba(0,0,0,.3);padding:0 30px;position: relative;min-height: 500px;  }
    .tit{height: 56px; line-height: 56px;padding-top: 15px;border-bottom:#ddd solid 1px;font-size: 16px;color: #333;position: absolute;top: 0;left: 30px;right: 30px; }
    .btm{height: 100px;border-top:#ddd solid 1px;position: absolute;bottom: 0;left: 30px;right: 30px;
    div{width: 88px; height: 35px; line-height: 35px; text-align: center;float: right;color: #fff;margin-top: 20px;-webkit-border-radius:3px;-moz-border-radius:3px;border-radius:3px;cursor: pointer;}
      .fal{margin-left: 10px;background: #bac7d8;}
      .tru{background: #00a3f0;}
    }
    span{position: absolute;right: 40px; top: 20px;font-size: 30px;color: #bac7d8;cursor: pointer;}
    .content-wrap{position: absolute;left: 30px;right: 30px;top: 72px;bottom:101px;overflow: hidden;}
    .content{overflow-y: scroll;width: 564px;height: 100%;}
    .p1{line-height: 18px;font-size: 12px;color: #666;padding-top: 20px;}
    .p2{font-size: 14px;color: #333;padding-top: 30px;}
  }
</style>



// WEBPACK FOOTER //
// agreement.vue?34d7582b